import { useSelector } from 'react-redux';
import { getTypeConfig } from 'common/utils/config';

function mergePromoSettingFields(formSettings, promoSettings, keys) {
    const newFormSettings = { ...formSettings };
    const hideStyleSettingKey = new Set([]);
    keys.forEach(([promoKey, formKey]) => {
        if (promoSettings[promoKey]) {
            newFormSettings[formKey] = promoSettings[promoKey];
            hideStyleSettingKey.add(formKey);
        }
    });
    return [newFormSettings, hideStyleSettingKey];
}

const formStyleSettingIsDefaultValue = {
    formContentTextColor: val => val === '#333333',
    formBtnBgColor: val => val === '#333',
    formBtnTextColor: val => val === '#fff'
};

function mergePromoStyle2FormStyle(formSettings, promoSettings, keys) {
    const newFormSettings = { ...formSettings };
    keys.forEach(([promoKey, formKey]) => {
        if (promoSettings[promoKey]) {
            const formSettingVal = newFormSettings[formKey];
            const chekcIsFormDefaultValue =
                formStyleSettingIsDefaultValue[formKey] || (() => false);
            if (
                !formSettingVal ||
                (Boolean(formSettingVal) && chekcIsFormDefaultValue(formSettingVal))
            ) {
                newFormSettings[formKey] = promoSettings[promoKey];
            }
        }
    });
    newFormSettings.formBg = promoSettings.defaultBg;
    newFormSettings.formContentBg = promoSettings.defaultContentBg;
    return newFormSettings;
}

export default function useFormStyleSetting() {
    const { templateType, promotionId } = useSelector(s => s.form);
    const { mergePromoSettingKeys } = getTypeConfig(templateType);
    const formSettings = useSelector(s => s.settings.form);
    const formVersion = useSelector(s => s.flag.formVersion);
    const promoSettings = useSelector(s => s.promoSettings);
    if (!promotionId) {
        return [formSettings, new Set([])];
    } else {
        const [newFormStyleSettings, hideStyleSettingKey] = (() => {
            if (formVersion === 1) {
                const settings = mergePromoStyle2FormStyle(
                    formSettings,
                    promoSettings,
                    mergePromoSettingKeys
                );
                return [settings, new Set([])];
            } else {
                return mergePromoSettingFields(formSettings, promoSettings, mergePromoSettingKeys);
            }
        })();
        return [newFormStyleSettings, hideStyleSettingKey];
    }
}
